export default "__VITE_ASSET__3d033a77__"